import React from 'react';
export function Footer() {
  return <footer className="w-full bg-black py-14" data-id="element-68" data-mp="32wd2qgad7ltj">
      <div className="mx-auto max-w-4xl px-6 text-center" data-id="element-69" data-mp="3gezf99jl213s">
        <p className="text-sm text-slate-400" data-id="element-70" data-mp="3ggkal1dq1o2p">© 2026 Digital Toolkit — All rights reserved.</p>
        <a href="mailto:soporte.digitaltoolkit@gmail.com" className="mt-2 inline-block text-sm font-medium text-white underline decoration-white/30 underline-offset-2 hover:decoration-white" data-id="element-71" data-mp="32pp4txyirn3c">
          soporte.digitaltoolkit@gmail.com
        </a>

        <p className="mx-auto mt-8 max-w-2xl text-xs leading-relaxed text-slate-500" data-id="element-72" data-mp="37ftv4932u2p">
          The Pharma-Masterclave is an educational digital resource designed to increase
          pharmaceutical literacy and safety awareness in the home environment. It is not a substitute for professional
          medical advice, diagnosis, or treatment. Always consult a licensed pharmacist or physician
          for specific medical guidance. Individual results may vary.
        </p>

        <nav className="mt-8 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-sm" aria-label="Footer" data-id="element-73" data-mp="3l8qvw2zluhqx">
          <a href="#" className="text-white hover:underline" data-id="element-74" data-mp="3gcjzp1x0gkm6">
            Terms and Conditions
          </a>
          <span className="text-slate-600" aria-hidden="true" data-id="element-75" data-mp="3v5df6nca90qu">
            |
          </span>
          <a href="#" className="text-white hover:underline" data-id="element-76" data-mp="3qaq0thaztmpz">
            Privacy Policy
          </a>
          <span className="text-slate-600" aria-hidden="true" data-id="element-77" data-mp="80nskgzggmbt">
            |
          </span>
          <a href="mailto:soporte.digitaltoolkit@gmail.com" className="text-white hover:underline" data-id="element-78" data-mp="31uotg9z09ou">
            Contact
          </a>
        </nav>
      </div>
    </footer>;
}